// src/context/WebviewContext.tsx
"use client";
import { createContext } from "react";
export const WebviewContext = createContext<boolean>(false);

export const WebviewProvider = ({
  children,
  value,
}: {
  children: React.ReactNode;
  value: boolean;
}) => {
  return (
    <WebviewContext.Provider value={value}>{children}</WebviewContext.Provider>
  );
};
